import { infiniteQueryOptions } from '@tanstack/react-query'
import { IStaffConfirmationStatus } from '#entities/staff'
import getStaffList from '../api/get-staff-list'

export const getStaffListQueryKey = (confirmationStatus: IStaffConfirmationStatus | null) =>
  ['staff-list', confirmationStatus] as const

export const getStaffListQueryOptions = (confirmationStatus: IStaffConfirmationStatus | null) =>
  infiniteQueryOptions({
    queryKey: getStaffListQueryKey(confirmationStatus),
    queryFn: ({ pageParam }) => getStaffList({ confirmationStatus, pageNumber: pageParam }),
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) => (lastPage.length ? allPages.length : undefined),
    staleTime: 60_000,
  })
